module.exports = __webpack_public_path__ + "static/media/nuparla em1 .1 w.b16a2211.png";